(function () {
  var filterToggle = document.querySelector('.filter-toggle');
  var filterDropdown = document.querySelector('.filter-dropdown');
  var applyBtn = document.querySelector('.apply-filters');
  var clearBtn = document.querySelector('.clear-filters');
  var searchForm = document.getElementById('blog-search-form');

  if (!filterToggle || !filterDropdown) return;

  // Toggle dropdown
  filterToggle.addEventListener('click', function () {
    filterDropdown.classList.toggle('is-open');
  });

  // Close dropdown on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('._filter-search-container')) {
      filterDropdown.classList.remove('is-open');
    }
  });

  // Build URL and navigate
  function navigate(search, categories) {
    var params = new URLSearchParams();
    if (search) params.set('s', search);
    if (categories) params.set('category', categories);
    var base = window.location.pathname.replace(/\/page\/\d+\/?/, '/');
    var qs = params.toString();
    window.location.href = qs ? base + '?' + qs : base;
  }

  // Apply category filters (preserve search)
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var checked = filterDropdown.querySelectorAll('input[type="checkbox"]:checked');
      var cats = Array.prototype.map.call(checked, function (cb) { return cb.value; }).join(',');
      var search = document.getElementById('blog-search-input').value.trim();
      navigate(search, cats);
    });
  }

  // Clear all filters
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      navigate('', '');
    });
  }

  // Search form submit (preserve categories)
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var search = document.getElementById('blog-search-input').value.trim();
      var urlParams = new URLSearchParams(window.location.search);
      navigate(search, urlParams.get('category') || '');
    });
  }
})();
